// v ist die Version des Stands im Ergebnis-Link (Spec 2026-10-06, 3.5), keine Antwort.
const getAnswersFromParams = params => {
    const items = {}

    params.forEach((value, key) => {
        if ('v' !== key) items[key] = parseInt(value)
    })

    return items
}

export default getAnswersFromParams
